import { useRef, useEffect } from 'react';

function IsolatedPage({ src }: { src: string }) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      // Optional: auto-resize
      try {
        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow?.document;
        if (iframeDoc) {
          iframe.style.height = `${iframeDoc.documentElement.scrollHeight}px`;
        }
      } catch (e) {
        // Cross-origin, can't auto-resize easily
      }
    };

    iframe.addEventListener('load', handleLoad);
    return () => iframe.removeEventListener('load', handleLoad);
  }, [src]);

  return (
    <iframe
      ref={iframeRef}
      src={src}
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        borderRadius: '0',
        overflow: 'hidden',
        display: 'block',
        position: 'relative',
        zIndex: '1',
      }}
      sandbox="allow-scripts allow-same-origin allow-popups"
      title="Isolated content"
    />
  );
}

export default IsolatedPage;
